module.exports = __webpack_public_path__ + "img/video-x.450f3cbf.png";